const Hero = () => {
  return (
    <section className='hero' id='home'>
      <div className='hero-banner'>
        <h1>Smart Compliance</h1>
        <p>
        Please upload a PDF or Word document. The system will assess its compliance with relevant laws and regulations and provide a compliance score. Ensure that any required follow-up actions are also addressed
        </p>
        <a href='#tours' className='btn hero-btn '>
           Check Compliance
        </a>
      </div>
    </section>
  )
}
export default Hero
